import styled, { css } from 'styled-components';

import backgroungImg from 'assets/sun-tornado.svg';

interface SearchBoxProps {
  hasSearched: boolean;
}

export const Container = styled.div`
  width: 100%;

  flex-direction: column;

  display: flex;
  justify-content: space-between;
`;

export const SearchBox = styled.div<SearchBoxProps>`
  width: 100%;
  height: 81vh;

  background: url(${backgroungImg}) no-repeat center fixed;
  background-size: cover;
  transition: height 0.3s;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.hasSearched &&
    css`
      height: 35vh !important;

      img {
        display: none;
      }
    `}

  @media only screen and (min-width: 1400px) {
    height: 86vh;
  }

  @media only screen and (max-height: 450px) {
    height: 100vh;
  }
`;

export const SearchBoxHeader = styled.div`
  width: 30%;
  margin: 30px 0;

  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    font-size: 40px;
    color: #fff;
  }

  @media only screen and (max-width: 1350px) {
    width: 100%;

    justify-content: center;

    h1 {
      text-align: center;
      font-size: 4.5vh;
    }

    svg {
      color: rgba(0, 0, 0, 0) !important;
    }
  }

  @media only screen and (max-height: 450px) {
    display: none;
  }
`;
